import { BodyLarge, Button } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import Reload from '@/design-lib/components/Icons/Reload'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { GTMEventCategory } from '@/utils/tracking/eventCategory'
import { handleShow } from '@/utils/tracking/eventsHandlers'

type Props = {
  className?: string
  gtmCategory: GTMEventCategory
}

export const GenericErrorContent: React.FC<Props> = ({ className, gtmCategory }) => {
  const { t } = useTranslation()
  const router = useRouter()
  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()

  useEffect(() => {
    handleShow(gtmCategory, 'Error')
  }, [])

  const handleButtonClick = () => {
    router.reload()
  }

  return (
    <div className={className}>
      <>
        <div className={sprinkles({ alignItems: 'center', display: 'flex', flexDirection: 'column' })}>
          <img
            alt=""
            className={sprinkles({ marginBottom: '2xl' })}
            height={120}
            src={`${imageBasePath}/images/concepts/broken-tv.svg`}
            width={120}
          />
          <div className={sprinkles({ marginBottom: '2xl', marginX: 'auto' })} style={{ maxWidth: 400 }}>
            <BodyLarge alignment="center">{t('suggested:Suggested_Error_Body')}</BodyLarge>
          </div>

          <Button
            data-testid="generic-error-confirm-button"
            Icon={() => <Reload />}
            label={t('suggested:Suggested_Error_CTA')}
            sizeVariant="medium"
            styleVariant="secondary"
            onClick={handleButtonClick}
          />
        </div>
      </>
    </div>
  )
}
